import { createFileRoute, redirect } from '@tanstack/react-router'
import toast from 'react-hot-toast'
import { object, optional, parse, string } from 'valibot'

import { AUTH0_SESSION_STORAGE_KEY } from '@/constants/auth0-session-storage-key'
import { ERROR_MESSAGES } from '@/constants/common/message.constants'
import { loginWithAuth0 } from '@/libs/api'

const searchSchema = object({
  code: optional(string()),
  state: optional(string())
})

export const Route = createFileRoute('/_public/login/callback')({
  validateSearch: (search) => parse(searchSchema, search),
  beforeLoad: async ({ search: { code, state } }) => {
    const auth_code = code
    const callbackState = state
    const sessionState = sessionStorage.getItem(AUTH0_SESSION_STORAGE_KEY)

    if (!auth_code || !callbackState) {
      toast.error(ERROR_MESSAGES.MISSING_AUTH_CODE_OR_STATE)
      throw redirect({
        to: '/login'
      })
    }

    if (!sessionState || sessionState !== callbackState) {
      toast.error(ERROR_MESSAGES.SESSION_VALIDATION_FAILED)
      throw redirect({
        to: '/login'
      })
    }

    try {
      await loginWithAuth0({ code })
      throw location.replace('/')
    } catch (error) {
      throw location.replace('/login')
    }
  }
})
